export default __webpack_public_path__ + "static/media/plus_icon_green.cf53cf5e.svg";